import SupportPage from 'src/components/support/SupportPage'
import { SupportPageProvider } from 'src/lib/contexts/SupportPageContext'

const Support = () => {
  return (
    <SupportPageProvider>
      <SupportPage />
    </SupportPageProvider>
  )
}

export default Support
